import clsx from "clsx";
import React from "react";

import * as gridStyles from "../Grid/styles.module.scss";
import * as styles from "./styles.module.scss";

type ResourceHubSkeletonProps = {};

const SkeletonGrid: React.FC<ResourceHubSkeletonProps> = () => {
  const classNames = clsx(gridStyles.grid, styles.skeleton);
  return (
    <div className={classNames}>
      <ul>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
        <li>
          <div className={styles.shimmer}></div>
          <div className={styles.shimmer}></div>
        </li>
      </ul>
    </div>
  );
};

export default SkeletonGrid;
